import {Component, inject, OnInit} from '@angular/core';
import {NzDescriptionsComponent, NzDescriptionsItemComponent} from "ng-zorro-antd/descriptions";
import {OrganizationService} from '@services/organization/organization.service';
import {Organization} from '@interfaces/organization';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {NzDividerComponent, NzDividerModule} from 'ng-zorro-antd/divider';
import {NzPageHeaderModule} from 'ng-zorro-antd/page-header';
import {NzBreadCrumbModule} from 'ng-zorro-antd/breadcrumb';
import {NzSpinComponent} from 'ng-zorro-antd/spin';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {TranslatePipe} from '@ngx-translate/core';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {AccountTypeEnum} from '@interfaces/doctors';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NonNullableFormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {NzInputDirective, NzInputGroupComponent} from 'ng-zorro-antd/input';
import { NzTableModule} from 'ng-zorro-antd/table';
import {NzOptionComponent, NzSelectComponent} from 'ng-zorro-antd/select';
import {NzTagComponent, NzTagModule} from 'ng-zorro-antd/tag';
import {EnumToStringPipe} from '../../../pipes/enum-to-string.pipe';
import {InvitationStatusEnum} from '@interfaces/organization';

@Component({
  selector: 'app-organization-detail',
  imports: [
    NzDescriptionsComponent,
    NzDescriptionsItemComponent,
    NzDividerComponent,
    NzBreadCrumbModule,
    RouterLink,
    NzSpinComponent,
    NzIconDirective,
    TranslatePipe,
    NzButtonComponent,
    NzPageHeaderModule,
    NzModalModule,
    NzFormModule,
    ReactiveFormsModule,
    NzInputGroupComponent,
    NzInputDirective,
    NzSelectComponent,
    NzOptionComponent,
    NzDividerModule,
    NzTableModule,
    NzTagComponent,
    NzTagModule,
  ],
  templateUrl: './organization-detail.component.html',
  styleUrl: './organization-detail.component.scss'
})
export class OrganizationDetailComponent implements OnInit {
  private organizationService = inject(OrganizationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private fb = inject(NonNullableFormBuilder);


  newUserForm = this.fb.group({
    email: this.fb.control('', [Validators.required, Validators.email]),
    role: this.fb.control(AccountTypeEnum.ORGANIZATION_ADMIN, [Validators.required]),
  });

  organization?: Organization;
  organizationId?: string;

  addUserModalVisible = false;
  loading = false;
  email = '';
  role = AccountTypeEnum.ORGANIZATION_ADMIN;
  roles = [
    {label: 'Organization Admin', value: AccountTypeEnum.ORGANIZATION_ADMIN},
    {label: 'Doctor', value: AccountTypeEnum.DOCTOR},
    {label: 'Admin', value: AccountTypeEnum.ADMIN},
    {label: 'Annotator', value: AccountTypeEnum.ANNOTATOR},
  ];
  orgInvitedUsers: any[] = [];
  orgRegisteredUsers: any[] = [];
  referral: any;

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const organizationId = params.get('organizationId');
      this.organizationId = organizationId || '';
      if (organizationId) {
        this.loadOrganization(organizationId);
        this.loadReferral();
      }
    });
  }

  loadReferral() { if(this.organizationId) this.organizationService.getReferralSettings(this.organizationId).subscribe(value => this.referral=value); }
  updateReferral(isActive: boolean, enabled: boolean) { if(this.organizationId) this.organizationService.updateReferralSettings(this.organizationId,{is_active:isActive,referral_enabled:enabled}).subscribe(()=>this.loadReferral()); }
  rotateReferral() { if(this.organizationId && window.confirm('Create a new canonical link and revoke the previous link?')) this.organizationService.createOrRotateReferralLink(this.organizationId).subscribe(()=>this.loadReferral()); }
  revokeReferral() { if(this.organizationId && window.confirm('Revoke this referral link for all future resolutions?')) this.organizationService.revokeReferralLink(this.organizationId).subscribe(()=>this.loadReferral()); }

  private loadOrganization(organizationId: string) {
    this.organizationService.fetchOrganization(organizationId)
      .subscribe((org: any) => {
        this.organization = org;
      });
    this.loadUsers();
  }

  loadUsers() {
    if(!this.organizationId) return;

    this.organizationService.getOrganizationInvitedUsers(this.organizationId)
      .subscribe((users: any[]) => {
        this.orgInvitedUsers = users;
      });

    this.organizationService.getOrganizationRegisteredUsers(this.organizationId)
      .subscribe((users: any[]) => {
        this.orgRegisteredUsers = users;
      });
  }

  goBack() {
    this.router.navigate(['/organization']);
  }

  openInvitationModal() {
    this.addUserModalVisible = true;
  }

  cancelUserAdd() {
    this.addUserModalVisible = false;
    this.resetForm();
  }

  resetForm() {
    this.newUserForm.reset();
    this.email = '';
    this.role = AccountTypeEnum.ORGANIZATION_ADMIN;
  }

  addUser() {
    if (!this.organization || this.newUserForm.invalid || !this.newUserForm.valid) return;
    this.loading = true;
    this.email = this.newUserForm.controls.email.value;
    this.role = this.newUserForm.controls.role.value;
    this.organizationService.inviteUser(this.organization?.id, this.email, this.role).subscribe({
      next: (res) => {
        this.addUserModalVisible = false;
        this.loading = false;
        this.loadUsers();
        this.resetForm();
      },
      error: (err) => {
        console.error('Error inviting user', err);
        this.loading = false;
      }
    })
  }

  protected readonly InvitationStatusEnum = InvitationStatusEnum;
}
